import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  accent?: boolean;
}

export default function SectionHeader({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  accent = false,
}: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="min-w-0">
        <div className="flex items-center gap-3">
          <span className={`w-1 h-6 rounded-full ${accent ? "bg-accent-500" : "bg-primary-500"}`}></span>
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">{title}</h2>
        </div>
        {subtitle && <p className="text-sm text-foreground-500 mt-2 ml-4">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 whitespace-nowrap transition-colors shrink-0"
        >
          {moreLabel}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      )}
    </div>
  );
}